export const rules = [
  'WebView',
  // iOS webview will be the same as safari but missing "Safari"
  '(iPhone|iPod|iPad)(?!.*Safari)',
  // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
  'Android.*(wv)',
  // old chrome android webview agent
  'Linux; U; Android',
]
